<template lang="pug">
</template>

<script>
export default {
  // Caixa de acesso ao módulo Gestão OS REURB dentro do análise
  created () {
    this.$store.commit('loader/SET_LOADER_WITH_TEXT', {
      status: true,
      text: 'Redirecionando ao módulo Gestão OS REURB...'
    })
    window.location.href = process.env.URL_GESTAO_OS_REURB
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaGestaoOSREURB.vue